import {
  Dashboard,
  BuyTokens,
  RequestTokens,
  SendTokens,
  WorkerSearch,
  BookingRequests,
} from 'containers/employer/pages';

import { ROUTE_EMPLOYER_PREFIX as ROUTE_PREFIX } from 'utils/routes';

const employerRoutes = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
  },
  {
    name: 'Buy Tokens',
    path: '/buy-tokens',
    component: BuyTokens,
  },
  {
    name: 'Request Tokens',
    path: '/request-tokens',
    component: RequestTokens,
  },
  {
    name: 'Send Tokens',
    path: '/send-tokens',
    component: SendTokens,
  },
  {
    name: 'Search workers',
    path: '/worker-search',
    component: WorkerSearch,
    exact: true,
    nav: true,
  },
  {
    name: 'Booking Requests',
    path: '/booking-requests',
    component: BookingRequests,
  },
];

const Routes = employerRoutes.map((route) => {
  return {
    ...route,
    path: `${ROUTE_PREFIX}${route.path}`,
    public: false,
    confirmedUser: true,
    employer: true,
  };
});

export default Routes;
